export default "__VITE_ASSET__bfd2a23a__"